var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app-title"},[_c('em-view-title',{key:"viewTitle",attrs:{"crudState":_vm.$_emCommonListMixin_pathType}})],1),_c('app-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }